import React from 'react';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

export const renderCustomAttributeValue = (value: unknown): React.ReactNode => {
  if (value === null || value === undefined || value === '') return '';
  if (typeof value === 'boolean') {
    return value
      ? <CheckOutlined style={{ color: 'green' }} />
      : <CloseOutlined style={{ color: 'lightgrey' }} />;
  }
  // antd Select 的 labelInValue 物件（{value, label}）可能被存進來，避免整頁 crash。
  if (typeof value === 'object') {
    const v = value as { value?: unknown; label?: unknown };
    if (v.value != null) return renderCustomAttributeValue(v.value);
    if (v.label != null) return String(v.label);
    return '';
  }
  return String(value);
};
